import React, { useEffect } from 'react'
import _ from 'lodash'

import Tree from 'components/common/Tree'

import Box from 'components_new/atoms/Box'
import Select from 'components_new/atoms/Select'
import Icon from 'components_new/atoms/Icon'
import IconButton from 'components_new/atoms/IconButton'
import MenuItem from 'components_new/atoms/Menu/MenuItem'

import { arrayToObject } from 'helpers/Functions'

import * as Conf from '../conf'

const Attributes = ({
  tables,
  tryGetRelatedTables,
  relations,
  checkedKeys,
  setCheckedKeys,
  mainTable,
  setMainTable,
  lockedMaintable,
  setLockedMaintable,
  setMapping,
  mapping
}) => {
  const height = (window.innerHeight * 50) / 100 //50vh in px

  useEffect(() => {
    if (mainTable && !relations[mainTable]) {
      tryGetRelatedTables(mainTable)
    }
  }, [mainTable])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: 2 }}
      >
        <Select
          sx={{ width: '100%' }}
          labelId="entity-to-go-from"
          label={'Välj entitet att utgå från'}
          value={mainTable}
          onChange={(value) => setMainTable(value.target.value)}
        >
          {(tables || []).map((t) => (
            <MenuItem key={t.id} value={t.id}>
              {t.attributes.name}
            </MenuItem>
          ))}
        </Select>
        <IconButton onClick={() => setLockedMaintable()}>
          <Icon
            color={lockedMaintable ? 'inherit' : 'primary'}
            name={lockedMaintable ? 'Lock' : 'LockOpen'}
          />
        </IconButton>
      </Box>
      <Tree
        height={height}
        data={Conf.getAttributeRows(
          mainTable,
          arrayToObject(tables),
          relations[mainTable]
        )}
        checkedKeys={checkedKeys}
        setCheckedKeys={(selected) => {
          const newMapping = _.cloneDeep(mapping)

          selected.forEach((key) => {
            if (
              !checkedKeys.find((key2) => key2 === key) &&
              key in newMapping
            ) {
              newMapping[key].keep = true
            }
          })

          setMapping(newMapping)
          setCheckedKeys(selected)
        }}
      />
    </Box>
  )
}

export default Attributes
